import { Text } from '@mantine/core';
import styled from 'styled-components';

const StyledBackButton = styled.button`
  margin-bottom: 20px;
  border: none;
  cursor: pointer;
  align-items: center;
  :hover {
    text-decoration: underline;
  }
`;
export const BackButton = ({ children, ...props }) => {
  return (
    <StyledBackButton {...props}>
      <Text>{children}</Text>
    </StyledBackButton>
  );
};
